var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.386 11.993a.664.664 0 0 0-.65.628 8.753 8.753 0 1 1-9.357-9.358.664.664 0 0 0 .627-.649.598.598 0 0 0-.627-.607C6.145 2.33 2 6.677 2 11.993 2 17.52 6.48 22 12.006 22c5.316 0 9.664-4.145 9.987-9.38a.598.598 0 0 0-.607-.627Z",
    fill: "currentColor"
  })));
};
export default SvgLoading;